<h4 class="section-title">Contacts</h4>
<div class="contacts-table-wrap" [attr.aria-busy]="isLoading() ? 'true' : null">
    @if (isLoading()) {
        <div class="dense-table mat-elevation-z0" style="min-height:8rem;display:flex;align-items:center;justify-content:center" role="status" aria-label="Loading contacts data">
            <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
            <div class="hint" style="margin-left: 0.75rem">Loading contacts data…</div>
        </div>
    } 
    @else {
        <table mat-table #contactTable="matTable"
            class="dense-table mat-elevation-z0" [dataSource]="contacts().controls">
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>Role</th>
                    <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
                    @if (isRowReadOnly(row)) {
                        <span class="cmdb-type-label">{{ getTypeDisplayLabel(row.controls.type.value) }}</span>
                    } @else {
                        <mat-form-field class="mat-form-field-no-margin"
                            appearance="outline" floatLabel="always">
                            <mat-select formControlName="type"
                                aria-label="Contact role"
                                [disabled]="isLoading() || isRowReadOnly(row)"
                                (selectionChange)="onContactTypeChange(i)">
                                @for (opt of contactTypeOptions; track opt.value)
                                {
                                    <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let row" [formGroup]="row">
                        <mat-form-field class="mat-form-field-no-margin contact-name-field" 
                        appearance="outline" floatLabel="always">
                        <input #contactNameInput matInput
                            class="cell-input cell-input-autocomplete"
                            type="text" placeholder="Enter name"
                            formControlName="name" aria-label="Contact name"
                                [disabled]="isLoading() || isRowReadOnly(row)"
                            [matAutocomplete]="contactNameAuto"/>

                        <mat-autocomplete #contactNameAuto="matAutocomplete"
                            (optionSelected)="onContactNameSelected(row, $event.option.value)">
                            @if ((contactNameSearch$(row) | async)?.loading) {
                                <mat-option disabled>Searching…</mat-option>
                            }
                            @for (opt of (contactNameSearch$(row) | async)?.results; track opt.value) {
                                <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                            }
                        </mat-autocomplete>
                        @if (row.controls.name.hasError('nameRequired')) {
                            <mat-error>Name is required.</mat-error>
                        }
                    </mat-form-field>
                </td>
            </ng-container>

            <ng-container matColumnDef="detail">
                <th mat-header-cell *matHeaderCellDef>Detail</th>
                <td mat-cell *matCellDef="let row" [formGroup]="row">
                    <mat-form-field class="mat-form-field-no-margin"
                        appearance="outline" floatLabel="always">
                        <input matInput class="cell-input" type="text" formControlName="contactDetail"
                            [disabled]="isLoading() || isRowReadOnly(row)"
                            [placeholder]="row.controls.type.value === 'Support Link' ? 'https://...': 'email@domain.com'"
                            aria-label="Contact detail"/>
                            @if (row.controls.contactDetail.hasError('linkRequired')) {
                                <mat-error>Link is required.</mat-error>
                            }
                            @if (row.controls.contactDetail.hasError('email')) {
                                <mat-error>Enter a valid email address.</mat-error>
                            }
                            @if (row.controls.contactDetail.hasError('url')) {
                                <mat-error>Enter a valid URL.</mat-error>
                            }
                    </mat-form-field>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="icon-col"></th>
                <td mat-cell *matCellDef="let row; let i = index" class="text-right actions-cell">
                    <button *ngIf="!isRowReadOnly(row)" type="button" class="icon-btn icon-btn--ms danger"
                        [disabled]="isLoading()"
                        (click)="removeContact(i)">
                        <span class="material-symbols-outlined">delete</span>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="['type','name','detail','actions']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['type', 'name', 'detail', 'actions']"></tr>  
            <tr class="mat-row" *ngIf="contacts().length === 0">
                <td class="mat-cell" colspan="4">
                    No contacts yet.
                </td>
            </tr>
        </table>
        <div class="link-row">
            <button type="button" class="link-btn" (click)="addContact()">
                + add contact
            </button>
        </div>
    }
</div>
